import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to CDN for faster image loading
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// DNS-prefetch for deferred Facebook Pixel
const dnsPrefetch = document.createElement('link');
dnsPrefetch.rel = 'dns-prefetch';
dnsPrefetch.href = 'https://connect.facebook.net';
document.head.appendChild(dnsPrefetch);
// Preload LCP image before React mounts
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.type = 'image/webp';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/p5uukvc9r3hYXLcg8oon7N/PROYECTOS-Anuales-_1080-x-900-px_-_5_.webp';
(preloadImg as any).fetchPriority = 'high';
document.head.appendChild(preloadImg);
render(<App data-id="element-298" />, document.getElementById('root'));